export default __webpack_public_path__ + "static/media/vi.ddb7cb1a.png";